import type { SearchAPIParams } from '@/domainLogic/index.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { FilterLabels } from './filtersAPIResponseTypes';
import type { FilterOptions } from './dynamicFiltersResponseTypes';
import getSearchParams from '../../common/getSearchParams';
import { removeAllFilters } from '../../components/Filters/utils.ts';

export const sortAlphabetically = (filterLabels: FilterLabels): FilterLabels => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const sorted = Object.entries(filterLabels).sort(([keyA, valA], [keyB, valB]) => (valB.label > valA.label ? -1 : 0));
  return sorted.reduce((result, [key, val]) => ({ ...result, [key]: val }), {});
};

export const convertToOptions = (filterLabels: FilterLabels, isChain?: boolean): FilterOptions =>
  Object.entries(filterLabels).reduce(
    (result: FilterOptions, [key, val]) =>
      result.concat({ value: `${key}`, label: isChain ? val.name || '' : val.label, addLabel: `${val.count}` }),
    []
  );

// A live search as far a Memsearch is concerned so it has to have the vcSearchId.
// The difference is that a FE Live search can become a Memsearch live search for example if the user
// chooses +- days from the calendar - in this case there is no vcSearchId or the adddays parameter is present.
type IsLiveSearchForMemsearch = {
  searchInfoData: SearchInfoData;
};
export const isLiveSearchForMemsearch = ({ searchInfoData }: IsLiveSearchForMemsearch): boolean => {
  const searchParams = getSearchParams();
  return (
    searchInfoData.isLiveSearch && !!searchParams?.[URLParameters.VC_SEARCH_ID] && !searchParams[URLParameters.ADD_DAYS]
  );
};

export const adaptParamsForAlternativeDates = (searchParams: SearchAPIParams): SearchAPIParams => {
  // @ts-ignore
  const params = { ...removeAllFilters(searchParams) } as SearchAPIParams;
  params.sort = 'nearest_departure';
  params.group = 5;
  params.limit = 20;
  params.stateful = 1;
  params.offset = 0;

  return params;
};
